module.exports = __webpack_public_path__ + "static/media/stijn-bessem-dna-placeholder-01.d3d16066.png";